import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { commaFormatNumber } from '@Utils/String';
import { recordCountOrResultSizeFromRelativeContextItem } from '@Containers/PatentFamilyClustering/selectors';
import { Button } from '@els/els-react--button';
import { mapContextToTitle } from '../ResultToolbarConstants';

export default function AvailableRelativeContextButton(props) {
  const { item, goToResultPage } = props;
  const context = item.get('context');
  const recordCountOrResultSize = recordCountOrResultSizeFromRelativeContextItem(item);
  const contextTitle = mapContextToTitle[context];

  if (!recordCountOrResultSize) {
    return <span>{`0 ${contextTitle}`}</span>;
  }

  return (
    <Button
      type="link"
      linkOptions={['inline', 'navigation']}
      className={`context-switcher-${context}`}
      onClick={() => {
        goToResultPage({
          resultName: item.get('resultName'),
          databaseId: item.get('databaseId'),
          context: item.get('context'),
          hitSetKey: item.get('hitSetKey'),
          resultSize: item.get('resultSize'),
          recordCount: item.get('recordCount'),
        });
      }}
      data-e2e="available-relative-context-button">
      {`${commaFormatNumber(recordCountOrResultSize)} ${contextTitle}`}
    </Button>
  );
}

AvailableRelativeContextButton.propTypes = {
  item: PropTypes.instanceOf(Map).isRequired,
  goToResultPage: PropTypes.func.isRequired,
};
